export const TreatmentStatus = {
  No: 'no',
  Created: 'created',
  Paid: 'paid',
  Shipped: 'shipped',
  Active: 'active',
  Completed: 'completed',
};
